import { bgSrc } from "@/lib/backgrounds";

// Fixed, dimmed photo behind the page. `strength` = how much of the theme colour covers the image.
export const BackgroundLayer = ({ id, strength = 0.82 }) => {
  const src = bgSrc(id);
  if (!src) return null;
  return (
    <div className="fixed inset-0 -z-10 pointer-events-none" aria-hidden="true" data-testid="app-background" data-bg={id}>
      <img src={src} alt="" className="w-full h-full object-cover" />
      <div className="absolute inset-0" style={{ background: `rgb(var(--bt-bg) / ${strength})` }} />
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at center, transparent 40%, rgb(var(--bt-bg) / 0.6) 100%)" }} />
    </div>
  );
};
